





















import { Component, Vue } from "vue-property-decorator";
import Table from "@/components/widgets/organisms/Table/Table.vue";
import Pagination from '@/components/widgets/organisms/Pagination/Pagination.vue';

import NewCartModal from "../../organisms/Modals/NewCart/NewCart.vue";

import {
  TRANSIT_REGISTER_GET_CARTS,
  SELECT_REGISTER_CART,
} from "@/store/TransitFacility/registers/actions";

import { SELECT_DOCUMENTS } from "@/store/photos/actions";

@Component({
  components: {
    Table,
    Pagination,
    NewCartModal,
  },
})

export default class RegisterCarts extends Vue {
  /* Data */
  private isLoaded: boolean = true;

  private params: any = {
    page: 1,
    size: 14,
  };

  private fixedHeader: any = [
    { key: "placa", label: "Placa", thClass: "dark-header" },
    { key: "tipo", label: "Tipo", thClass: "dark-header" },
    { key: "marca", label: "Marca", thClass: "dark-header" },
    { key: "qtdCompartimentos", label: "Quantidade compartimentos", thClass: "dark-header" },
    { key: "capacidade", label: "Capacidade", thClass: "dark-header" },
    { key: "bezerreira", label: "Bezerreira", thClass: "dark-header" },
    { key: "descricao", label: "Descrição", thClass: "dark-header" },
    { key: "foto", label: "Fotos", thClass: "dark-header", tdClass: "td-photo"},
    { key: "actions", label: "Ações", tdClass: "td-action" },
  ]

  private rows: any = [];

  private totalPages: number = 0;

  /* Lifecycle */
  created() {
    this.getCarts(this.params);
  }
  
  /* Methods */
  getCarts(params: any) {
    this.isLoaded = false
    this.$store
      .dispatch(TRANSIT_REGISTER_GET_CARTS, params)
      .then(({totalCount, results}) => {
        if (results.length == 0) {
          this.$toast.error("Nenhuma carreta encontrada");
          return;
        }
        this.totalPages = totalCount;
        this.rows = results.map((i) => {
          return {
            ...i,
            bezerreira: i.bezerreira ? "Sim" : "Não",
            foto: { docs: i.fotos },
            actions: {
              id: i.idCarreta,
              buttons: ["edit"],
            },
          };
        });
      })
      .catch((e) => {
        this.$toast.error(e);
      })
      .finally(() => {
        this.isLoaded = true;
      });
  }

  message(message, variant, reload = false) {
    if(reload) this.getCarts(this.params);
    this.$nextTick(() => {
      this.$toast.open({
        message,
        type: variant,
      });
    });
  }

  onChangePage(page) {
    this.params.page = page;
    this.getCarts(this.params);
  }

  onChangeSize(size) {
    this.params.size = size;
    this.params.page = 1;
    this.getCarts(this.params);
  }

  openDocuments(documents){
    this.$store.dispatch(SELECT_DOCUMENTS, documents);
  }

  openEdit(value) {
    this.$store.dispatch(SELECT_REGISTER_CART, value.id);
  }
}
